import React from 'react';

export const ContentTypeIcon = React.memo((props) => {
  var useTag = `<use xlink:href="#${props.id}" />`;
  return <svg aria-hidden="true" focusable="false" className="pavilion-icon" dangerouslySetInnerHTML={{__html: useTag }} />;
})